<template>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="800">
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                dark
                v-bind="attrs"
                v-on="on"
                @click="showCheckoutModal" 
                >
                <v-badge color="black">
                    <span slot="badge">{{numProductsCart}}</span>  
                    <v-icon>mdi-cart</v-icon>
                </v-badge> 
            </v-btn>
        </template>
        <v-card>
        <v-card-title >
            Checkout
            <v-spacer></v-spacer>
            <v-btn icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <product  v-for="product in products" v-bind:item="product" v-bind:key="product.id" :product="product"></product>
            <div v-if="products.length === 0">
                <p>Carrinho vazio</p>
            </div>					
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                link
                @click="clearCart()">
                Limpar carrinho
            </v-btn>
            <v-btn
                dark
                @click="dialog = false"
                :to="'/checkout'">
                Prosseguir
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>   
</template>

<script>

    import {CLEAR_CART} from '../../store/actions/store.js';
    import Product from '../cart/ModalProduct';

    export default {
        components:{
            'product' : Product
        },
        data () {
            return {
                dialog: false,
            }
        },
        methods:{
            showCheckoutModal:function () {
                this.$store.commit('CHECKOUT_MODAL', true);
            },            
            clearCart(){
                 this.$store.dispatch(CLEAR_CART)
                .then(() => {
                    this.dialog = false;
                });
            }
        },
        computed: {
            numProductsCart: function(){
                return this.$store.getters.numProductsCart;
            },
            products (){
                return this.$store.getters.productsAdded;
            }
        }
    }
</script>